/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-08-17 11:51:10
 * @LastEditors: 
 * @LastEditTime: 2020-08-17 11:52:14
 */
import Modal from './modal';

export default Modal